export default {
  mainTitle: {
    id: 'seo_footer_links_main_title',
    defaultMessage: 'Trade in these devices on Back Market for cash back',
  },
  tabsLabel: {
    id: 'seo_footer_links_tabs_label',
    defaultMessage: 'Device categories',
  },
  seeMore: {
    id: 'seo_footer_links_see_more',
    defaultMessage: 'See more',
  },
}
